<template>
  <div class="app-modals">
    <cms-order-modal
      v-if="cmsOrder"
      :runtime="cmsOrder.runtime"
      :market="cmsOrder.market"
      :intent="cmsOrder.intent"
      embedded-journey
      @close="cmsOrder.runtime.closeOrder()"
      @completed="cmsOrder.runtime.closeOrder()"
    />
    <modal
      v-if="isCurrentModal(MODALS.LOGIN)"
      :gtm="gtmLogin"
      :bodyClass="footerHideBodyClass"
      :closeButton="!isUserRestricted && canCloseAuth"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Login</div>
      </template>
      <template v-slot:content>
        <account-login
          :email="currentPopupOptions.email"
          :redirect-after-login="currentPopupOptions.redirectAfterLogin !== false"
        ></account-login>
      </template>
      <template v-slot:footer>
        <account-login-footer v-if="!isUserRestricted && !isShutdownModeOn"></account-login-footer>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.FORGOTTEN)"
      gtm="forgotten"
      bodyClass="modal__body--medium"
      @modalClose="closeModal()"
      :closeButton="canCloseAuth"
    >
      <template v-slot:header>
        <div>Forgotten Password</div>
      </template>
      <template v-slot:content>
        <account-forgotten></account-forgotten>
      </template>
      <template v-slot:footer>
        <account-forgotten-footer></account-forgotten-footer>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.ACCOUNT_ALREADY_EXISTS)"
      bodyClass="modal__body--medium"
      :closeButton="true"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Account Already Exists</div>
      </template>
      <template v-slot:content>
        <account-already-exists :email="currentPopupOptions.email"></account-already-exists>
      </template>
      <template v-slot:footer>
        <account-already-exists-footer></account-already-exists-footer>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.ACCOUNT_ENABLE_CLASSIC)"
      bodyClass="modal__body--medium"
      :closeButton="true"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Enable PredictIt Classic</div>
      </template>
      <template v-slot:content>
        <account-enable-classic-predictit></account-enable-classic-predictit>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.RESET_PASSWORD)"
      gtm="reset-password"
      bodyClass="modal__body--medium"
      @modalClose="closeModal()"
      :closeButton="canCloseAuth"
    >
      <template v-slot:header>
        <div>Reset Your Password</div>
      </template>
      <template v-slot:content>
        <account-reset-password :token="currentPopupOptions.token"></account-reset-password>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.REGISTER)"
      :gtm="gtmSignUp"
      :bodyClass="footerHideBodyClass"
      @modalClose="closeModal()"
      :closeButton="canCloseAuth"
    >
      <template v-slot:header>
        <div>Create an Account</div>
      </template>
      <template v-slot:content>
        <account-register></account-register>
      </template>
      <template v-slot:footer>
        <account-register-footer></account-register-footer>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.REGISTER_EXTERNAL)"
      gtm="SignUp-external"
      bodyClass="modal__body--medium"
      @modalClose="closeModalWithLogout()"
    >
      <template v-slot:header>
        <div>Create an Account</div>
      </template>
      <template v-slot:content>
        <account-register-external></account-register-external>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.ACCOUNT_VERIFY)"
      :gtm="gtmAccountVerify"
      bodyClass="modal__body--medium"
      @modalClose="closeAccountVerifyModal()"
    >
      <template v-slot:header>
        <div>
          <template
            v-if="
              currentPopupOptions &&
              currentPopupOptions.formType === constants.FORM_TYPE_IDV.SSN4IDV
            "
          >
            Identity Verification
          </template>
          <template v-else> Personal Details </template>
        </div>
      </template>
      <template v-slot:content>
        <account-details-verify
          :formType="currentPopupOptions.formType || undefined"
          :trigger="currentPopupOptions.trigger || undefined"
        ></account-details-verify>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.UPLOAD_ID)"
      gtm="upload-id"
      bodyClass="modal__body--medium"
      headerClass="modal__header--small modal__header--gray"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>We are unable to verfiy your identity</div>
      </template>
      <template v-slot:content>
        <account-upload-id></account-upload-id>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.UPLOAD_DOCUMENT)"
      gtm="upload-document"
      bodyClass="modal__body--medium"
      headerClass="modal__header--small modal__header--gray"
      @modalClose="closeModal()"
    >
      >
      <template v-slot:header>
        <div>
          <template v-if="currentPopupOptions.isPending">Identity Verification Pending </template>
          <template v-else>Document Upload Required </template>
        </div>
      </template>
      <template v-slot:content>
        <account-upload-document
          :source="currentPopupOptions.source"
          :isPending="currentPopupOptions.isPending"
          :isPopup="true"
        ></account-upload-document>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.TAX_INFO)"
      bodyClass="modal__body--medium"
      :closeButton="true"
      @modalClose="closeModal()"
    >
      <!--:closeButton="!isTaxNotificationMandatory"-->
      <template v-slot:header>
        <div>Tax Information</div>
      </template>
      <template v-slot:content>
        <tax-info-notification></tax-info-notification>
      </template>
    </modal>
    <small-modal
      v-if="isCurrentModal(MODALS.ATTACH_TO_HOME)"
      type="top-alt"
      :padding="false"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Add to Home Screen</div>
      </template>
      <template v-slot:content>
        <attach-to-home></attach-to-home>
      </template>
    </small-modal>
    <modal
      v-if="isCurrentModal(MODALS.ORIENTATION)"
      bodyClass="modal__body--full"
      :closeButton="false"
      :fullScreen="true"
      @modalClose="closeModal()"
    >
      <template v-slot:content>
        <orientation-info></orientation-info>
      </template>
    </modal>
    <account-details-update-modal
      v-if="
        isCurrentModal(MODALS.ACCOUNT_DETAIL_UPDATE) ||
        isCurrentModal(MODALS.ACCOUNT_DETAIL_PASSWORD) ||
        isCurrentModal(MODALS.ACCOUNT_DETAIL_PASSWORD_SET) ||
        isCurrentModal(MODALS.ACCOUNT_ADDRESS_UPDATE)
      "
      :what="currentPopup"
    >
    </account-details-update-modal>
    <modal
      v-if="isCurrentModal(MODALS.ADD_FUNDS)"
      bodyClass="modal__body--quick-deposit modal__body--show-ready"
      closeButtonClass="modal__close--quick-deposit"
      :gtm="gtmAddFunds"
      @modalClose="addFundsClose()"
    >
      <template v-slot:header>
        <div>Quick Deposit</div>
      </template>
      <template v-slot:content>
        <add-funds-combined
          :checkInstantCredit="currentPopupOptions.checkInstantCredit"
        ></add-funds-combined>
      </template>
      <template v-slot:footer>
        <add-funds-combined-footer></add-funds-combined-footer>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.PAYMENT_SUCCESS)"
      :closeButton="!currentPopupOptions.noClose"
      bodyClass="modal__body--medium"
      @modalClose="closePaymentSuccessModal()"
    >
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <generic-popup>
          <template v-slot:content>
            <div>
              <deposited></deposited>
              <br />
              <button
                @click="paymentSuccessDone"
                class="button button--large button--submit button--full-width"
              >
                <span> Done </span>
              </button>
              <div class="app-modals__payment-success-get-in-actions">
                Get in the action:
                <router-link :to="{ name: 'market-list' }" @click="closePaymentSuccessModal"
                  >View All Markets</router-link
                >
              </div>
            </div>
          </template>
        </generic-popup>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.PAYMENT_ERROR)"
      bodyClass="modal__body--medium"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <generic-popup>
          <template v-slot:content>
            <div>
              <p v-if="currentPopupOptions.error" v-html="currentPopupOptions.error"></p>
              <p v-else>Unfortunately, we could not process your payment.</p>
            </div>
          </template>
        </generic-popup>
      </template>
    </modal>
    <potential-payouts
      v-if="isCurrentModal(MODALS.POTENTIAL_PAYOUTS)"
      :market="currentPopupOptions.market"
      @modalClose="closeModal()"
    >
    </potential-payouts>
    <market-contracts-stats-popup
      v-if="isCurrentModal(MODALS.MARKET_CONTRACT_STATS)"
      :stats="currentPopupOptions.stats"
      :isFixed="currentPopupOptions.isFixed"
      @modalClose="closeModal()"
    >
    </market-contracts-stats-popup>
    <offers-indicator-popup
      v-if="isCurrentSmallModal(MODALS.SMALL_OFFERS_INDICATOR)"
      :items="currentPopupOptions.items"
      :operationType="currentPopupOptions.operationType"
      :price="currentPopupOptions.price"
      @modalClose="closeSmallModal()"
    >
    </offers-indicator-popup>
    <modal
      v-if="isCurrentModal(MODALS.RESEARCH)"
      bodyClass="modal__body--gray modal__body--medium"
      :noPadding="true"
      gtm="research"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Research Opportunities</div>
      </template>
      <template v-slot:content>
        <research></research>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.TWITTER)"
      bodyClass="modal__body--medium"
      :noPadding="true"
      :clickOutsideEnabled="true"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Latest Tweets</div>
      </template>
      <template v-slot:content>
        <twitter-timeline :inOverlay="true"></twitter-timeline>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.NEWS_FEED)"
      bodyClass="modal__body--medium"
      :noPadding="true"
      :clickOutsideEnabled="true"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Latest News</div>
      </template>
      <template v-slot:content>
        <news-feed :inOverlay="true" :marketId="currentPopupOptions.marketId"></news-feed>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.PURCHASE_SUSHI_REVIEW)"
      @modalClose="closeModal()"
      bodyClass="modal__body--slim"
      :noPadding="true"
    >
      <template v-slot:header>
        <div>Review and Confirm Order</div>
      </template>
      <template v-slot:content>
        <purchase-review-and-confirm-sushi :market="tradePopupOptions.market">
        </purchase-review-and-confirm-sushi>
      </template>
    </modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_SWIFT)">
      <template v-slot:header>
        <div>Info</div>
      </template>
      <template v-slot:content>
        <div>Text</div>
      </template>
    </small-modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_CVV)">
      <template v-slot:header>
        <div>Where is my CVV?</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/images/cvv2.jpg" />
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_VERIFICATION_INFO)"
    >
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer" v-if="currentPopupOptions.verificationStatus === 0">
            You need to have your identity verified in order to make a deposit. Click "Verify" to
            provide the necessary information.
          </p>
          <p class="modal-small__disclaimer" v-if="currentPopupOptions.verificationStatus === 1">
            Some deposits and withdrawals will require us to perform an enhanced verification check.
            Click on "Upgrade" to prevent a delay in processing your transactions.
          </p>
          <p class="modal-small__disclaimer" v-if="currentPopupOptions.verificationStatus === 2">
            Your identification documents are under review. We will notify you by email regarding
            your status within 72 hours of submission. You will be able to deposit funds once your
            identify has been confirmed. Thank you for your patience.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_ROUTING_NUMBER)"
    >
      <template v-slot:header>
        <div>Sample Check</div>
      </template>
      <template v-slot:content>
        <div>
          <img v-asset-cdn-src="`/static/img/check.96fa935.jpg`" />
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_EDIT_IMAGE)"
    >
      <template v-slot:header>
        <div>Change Profile Image</div>
      </template>
      <template v-slot:content>
        <div>
          <account-update-image></account-update-image>
        </div>
      </template>
    </small-modal>
    <insight-modal v-if="isCurrentModal(MODALS.INSIGHT)" @modalClose="closeModal()">
    </insight-modal>
    <!-- generic popups for errors and toasts -->
    <modal
      v-if="isCurrentModal(MODALS.GENERIC)"
      bodyClass="modal__body--gray"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <generic-popup>
          <template v-slot:content>
            <div v-if="currentPopupOptions.content">
              {{ currentPopupOptions.content }}
            </div>
          </template>
        </generic-popup>
      </template>
    </modal>
    <modal
      :autoClose="false"
      v-if="isCurrentSmallModal(MODALS.SMALL_MARKET_RULES)"
      @modalClose="closeSmallModal()"
      overlayTheme="z-index-plus-one"
    >
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <div class="app-modals__rules">
          <market-rules
            :market="currentPopupOptions.market"
            :showExpanded="true"
            :dateEnd="currentPopupOptions.market.dateEndString"
            :rules="currentPopupOptions.market.rule"
          ></market-rules>
        </div>
      </template>
    </modal>
    <small-modal
      :autoClose="true"
      v-if="isCurrentSmallModal(MODALS.SMALL_GENERIC)"
      @modalClose="closeSmallModal()"
    >
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <generic-small-popup>
          <template v-slot:content>
            <div v-if="currentPopupOptions.content">
              {{ currentPopupOptions.content }}
            </div>
          </template>
        </generic-small-popup>
      </template>
    </small-modal>
    <small-modal
      v-if="isCurrentModal(MODALS.EXPORT_TRADE_HISTORY)"
      :padding="false"
      @modalClose="closeModalHideOverlay()"
    >
      <template v-slot:header>
        <div>
          <template v-if="$route.query && $route.query.contractId">
            Export Contract History
          </template>
          <template v-else-if="$route.params.marketId && $route.params.marketId !== 'all'">
            Export Market History
          </template>
          <template v-else> Export Trade History </template>
        </div>
      </template>
      <template v-slot:content>
        <div>
          <export-history kind="trade"></export-history>
        </div>
      </template>
    </small-modal>
    <small-modal
      v-if="isCurrentModal(MODALS.EXPORT_TRANSACTION_HISTORY)"
      :padding="false"
      @modalClose="closeModalHideOverlay()"
    >
      <template v-slot:header>
        <div>Export Transaction History</div>
      </template>
      <template v-slot:content>
        <div>
          <export-history kind="transaction"></export-history>
        </div>
      </template>
    </small-modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_USERNAME)">
      <template v-slot:header>
        <div>Username</div>
      </template>
      <template v-slot:content>
        <div>
          <img v-asset-cdn-src="`/static/img/avatar.9ff8844.svg`" />
          <p class="modal-small__disclaimer">
            A username is required to preserve your anominity when using third-party services.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_TRADE_INFO)"
    >
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            <template v-if="currentPopupOptions.completeInfo">
              "Net P/L" is the sum of your profit/loss<br />
              and any trading fees. <br /><br />
            </template>
            Figures are calculated to the tenth of a cent, but rounded for display purposes.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_OWNERSHIP_INFO)"
    >
      <template v-slot:header>
        <div>Minimum Ownership</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            Traders are required to purchase and maintain a minimum ownership of
            {{ currentPopupOptions.shares }} share<template v-if="currentPopupOptions.shares > 1"
              >s</template
            >
            in this contract.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_ROI_INFO)">
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            Return on Investment (ROI) is calculated as the % gain or loss in the value of your
            portfolio over the time period. Deposits and withdrawals during that period are not
            included in this calculation. You must have a minimum portfolio value of $10 at both the
            beginning and end of the period to appear on the leaderboard.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_FEE_INFO)">
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            The fees listed here are the fees that PredictIt charges and do not include fees charged
            by any bank, crypto-network, or other 3rd party involved in transferring money.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal @modalClose="closeSmallModal()" v-if="isCurrentSmallModal(MODALS.SMALL_WINS_INFO)">
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            You are credited with a win whenever you sell a share at a profit.
          </p>
          <p class="modal-small__disclaimer">Trophies for Wins are awarded as follows:</p>
          <leaderboards-trophy-pyramid></leaderboards-trophy-pyramid>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_LEADERBOARDS_UPDATE_INFO)"
    >
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            Leaderboards are updated nightly. Your preference will be reflected in the next update.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_ANNOUNCEMENT)"
    >
      <template v-slot:header>
        <div>Announcement</div>
      </template>
      <template v-slot:content>
        <announcement :announcement="currentPopupOptions.announcement"> </announcement>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_PUBLIC_PROFILE_INFO)"
    >
      <template v-slot:header>
        <div>About Your Profile</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            To make PredictIt more fun and social in the future we will allow traders to share
            information from their profiles. If there is anything you would rather keep private you
            can always mark it as hidden. On your profile pages hidden items are still shown but
            include an asterisk (*) to let you know they are hidden from other users.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_RESTRICTED_FUNDS_INFO)"
    >
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            Funds awarded as part of promotional offer cannot be withdrawn until traded.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_SHARE_INVITE_INFO)"
    >
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <div>
          <img src="@/assets/icons/info-big.svg" />
          <p class="modal-small__disclaimer">
            Separate multiple email addresses with a semi-colon.
          </p>
        </div>
      </template>
    </small-modal>
    <small-modal v-if="isCurrentSmallModal(MODALS.SMALL_MESSAGING_JOURNEY)" :closeButton="false">
      <template v-slot:header>
        <div>Information</div>
      </template>
      <template v-slot:content>
        <messaging-journey-info> </messaging-journey-info>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_PWMB_ACCOUNT_CONFIRM_DELETE)"
    >
      <template v-slot:header>
        <div>Confirmation</div>
      </template>
      <template v-slot:content>
        <div>
          <p>Are you sure you want to remove this bank authorization?</p>
          <div class="add-funds-bank-transfer__buttons">
            <button
              class="button button--large button--primary button--full-width"
              @click.stop="currentPopupOptions.onConfirm"
            >
              Yes
            </button>
            <button
              autofocus
              class="button button--large button--primary button--full-width button--focused"
              @click.stop="closeSmallModal()"
            >
              No
            </button>
          </div>
        </div>
      </template>
    </small-modal>
    <modal
      headerClass="modal__header--light modal__header--no-border"
      bodyClass="modal__body--medium"
      :autoClose="false"
      v-if="isCurrentSmallModal(MODALS.SMALL_BADGES)"
      @modalClose="closeSmallModal()"
    >
      <template v-slot:header>
        <div>Badges</div>
      </template>
      <template v-slot:content>
        <account-badges-list class="modal__content--badges"></account-badges-list>
      </template>
    </modal>
    <modal
      headerClass="modal__header--light modal__header--no-border"
      bodyClass="modal__body--medium"
      :autoClose="false"
      v-if="isCurrentSmallModal(MODALS.SMALL_USER_PROFILE)"
      @modalClose="closeSmallModal()"
    >
      <template v-slot:header>
        <user-profile-overview-header></user-profile-overview-header>
      </template>
      <template v-slot:content>
        <user-profile-overview></user-profile-overview>
      </template>
    </modal>
    <modal
      headerClass="modal__header--light modal__header--no-border"
      bodyClass="modal__body--medium"
      :autoClose="false"
      v-if="isCurrentSmallModal(MODALS.SMALL_REPORT_USER)"
      @modalClose="closeUserReportModal()"
    >
      <template v-slot:header>
        <div>Report User</div>
      </template>
      <template v-slot:content>
        <user-report></user-report>
      </template>
    </modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.COINBASE)"
      :wide="true"
      :padding="true"
    >
      <template v-slot:header> Process Overview </template>
      <template v-slot:content>
        <coinbase-process-overview
          :depositPayload="currentPopupOptions.depositPayload"
        ></coinbase-process-overview>
      </template>
    </small-modal>
    <modal
      v-if="collegeAffiliationEnabled && isCurrentModal(MODALS.COLLEGE_AFFILIATION)"
      :closeButton="!!currentPopupOptions.allowClose"
      :noPadding="true"
      bodyClass="modal__body--slim modal__body--show-ready modal__body--no-overflow"
      @modalClose="closeAffiliationsModal"
    >
      <template v-slot:header>
        <div>College Affiliation</div>
      </template>
      <template v-slot:content>
        <affiliations-popup @affiliationsSubmitted="onAffiliationsSubmitted"> </affiliations-popup>
      </template>
    </modal>
    <modal v-if="isCurrentModal(MODALS.VIDEO)" @modalClose="closeModal">
      <template v-slot:header>
        <div>{{ currentPopupOptions.title }}</div>
      </template>
      <template v-slot:content>
        <div>
          <br />
          <youtube player-width="100%" :player-height="400" :video-id="currentPopupOptions.id">
          </youtube>
          <div class="app-modals__note">
            For more information on how to trade on PredictIt, visit our
            <router-link :to="{ name: 'HelpAndSupport' }" class="app-modals__note-link"
              >Support</router-link
            >
            page.
          </div>
        </div>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.MARKET_OWNERSHIP_CONFLICT)"
      bodyClass="modal__body--large"
      :noPadding="true"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Market Ownership Conflict</div>
      </template>
      <template v-slot:content>
        <market-ownership-conflict-modal
          :restrictions="currentPopupOptions.restrictions"
          :restrictionPreamble="currentPopupOptions.restrictionPreamble"
        ></market-ownership-conflict-modal>
      </template>
    </modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_SHARE_INFO)"
      :wide="true"
      :padding="false"
    >
      <template v-slot:header>
        <div>Info</div>
      </template>
      <template v-slot:content>
        <share-info-popup :item="currentPopupOptions.item"> </share-info-popup>
      </template>
    </small-modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_PAYOUT_INFO)"
      :wide="true"
      :padding="false"
    >
      <template v-slot:header>
        <div>Info</div>
      </template>
      <template v-slot:content>
        <div>
          <p class="modal-small__disclaimer">
            This is the estimated payout if your order is matched at the minimum sell price. Actual
            figures may differ if your order is matched at more favorable prices.
          </p>
        </div>
      </template>
    </small-modal>
    <!-- Two-Factor Authentication Modals -->
    <modal
      v-if="isCurrentModal(MODALS.TWO_FACTOR)"
      bodyClass="modal__body--medium"
      :closeButton="false"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Two-Factor Authentication</div>
      </template>
      <template v-slot:content>
        <account-two-factor-verify
          :redirect-after-login="currentPopupOptions.redirectAfterLogin !== false"
        ></account-two-factor-verify>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.TWO_FACTOR_PROMPT)"
      bodyClass="modal__body--medium"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Security Recommendation</div>
      </template>
      <template v-slot:content>
        <account-two-factor-prompt></account-two-factor-prompt>
      </template>
    </modal>
    <modal
      v-if="isCurrentModal(MODALS.PHONE_UPDATE)"
      bodyClass="modal__body--medium"
      @modalClose="closeModal()"
    >
      <template v-slot:header>
        <div>Update Phone Number</div>
      </template>
      <template v-slot:content>
        <account-phone-update @close="closeModal()" @verified="closeModal()"></account-phone-update>
      </template>
    </modal>
    <!-- reCAPTCHA v2 Challenge Modal (fallback when v3 score fails) -->
    <modal
      v-if="isCurrentModal(MODALS.RECAPTCHA_CHALLENGE)"
      bodyClass="modal__body--medium"
      :closeButton="false"
    >
      <template v-slot:header>
        <div>Additional Verification Required</div>
      </template>
      <template v-slot:content>
        <div class="recaptcha-challenge-modal">
          <template v-if="recaptchaVerifying">
            <div class="recaptcha-challenge-modal__loading">
              <div class="recaptcha-challenge-modal__spinner"></div>
              <p class="recaptcha-challenge-modal__message">
                Verification successful! Processing your request...
              </p>
            </div>
          </template>
          <template v-else>
            <p class="recaptcha-challenge-modal__message">
              Please verify that you are not a robot to continue.
            </p>
            <captcha
              :key="currentPopupOptions.attempt || 1"
              @update:modelValue="onRecaptchaChallengeComplete"
            ></captcha>
          </template>
        </div>
      </template>
    </modal>
    <small-modal
      @modalClose="closeSmallModal()"
      v-if="isCurrentSmallModal(MODALS.SMALL_PRICE_ODDS)"
      :info="true"
      :closeButton="true"
    >
      <template v-slot:header>
        <div>Info</div>
      </template>
      <template v-slot:content>
        <div>
          <price-odds-toggle-popup></price-odds-toggle-popup>
          <br />
          <button
            @click="closeSmallModal"
            class="button button--large button--black button--full-width"
          >
            <span> Close </span>
          </button>
        </div>
      </template>
    </small-modal>
    <modal
      v-if="isCurrentModal(MODALS.CUSTOMIZE_YOUR_PREDICTIT)"
      bodyClass="modal__body--xlarge"
      :noPadding="true"
      @modalClose="closeWhatIsNewPopup()"
    >
      <template v-slot:header>
        <div>Customize Your PredictIt</div>
      </template>
      <template v-slot:content>
        <what-is-new-popup></what-is-new-popup>
      </template>
      <template v-slot:footer>
        <what-is-new-popup-footer></what-is-new-popup-footer>
      </template>
    </modal>
  </div>
</template>

<script src="./app-modals.js"></script>
<style src="./app-modals.scss" lang="scss"></style>
